'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CallOut = function CallOut(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M13.48 11.82C14.59 12.18 15.78 12.38 17.01 12.38C17.55 12.38 18 12.83 18 13.37V16.82C18 17.37 17.72 18 17.01 18C7.73 18 0 10.28 0 0.99C0 0.24 0.65 0 1.19 0H4.65C5.19 0 5.64 0.45 5.64 0.99C5.64 2.22 5.83 3.41 6.2 4.52C6.31 4.87 6.23 5.26 5.96 5.54L4.01 7.2C5.42 10.13 8.07 12.68 10.9 14.03L12.47 12.06C12.74 11.79 13.13 11.7 13.48 11.82Z"
  }), React__default["default"].createElement("path", {
    d: "M11.3431 0.99702V0L17.9896 0.010407L18 6.65685H17.003L16.9994 1.70766L11.6967 7.01041L10.9896 6.3033L16.2923 1.00056L11.3431 0.99702Z"
  }));
};

var CallOut$1 = iconStyles()(CallOut);

module.exports = CallOut$1;
